import { schema } from 'normalizr'

const requestMarketingEvaluation = new schema.Object({})

const request = new schema.Entity(
    'requests',
    {
        request_marketing_evaluation: requestMarketingEvaluation,
    },
    { idAttribute: 'request_id' },
)

export default [
    new schema.Entity(
        'anonymizedRequests',
        {
            request,
        },
        { idAttribute: 'anonymized_request_id' },
    ),
]
